import { useEffect, useState } from "react";
import GetFormaCompView from "../Vue/Pages/GetFormaCompView";
import { useParams } from "react-router-dom";
import TrainingService from "../Service/TrainingService";
import TrainingModel from "../Model/TrainingModel";

const GetFormaCompController = () => {

  const [training, setTraining] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formationsData, setFormationsData] = useState();
  const { id } = useParams();

  useEffect(() => {
    fetchTraining();
  }, [])

  const fetchTraining = async () => {
    try {
      let response = await TrainingService.fetchModifTrainingById(id);
      let trainingMod = new TrainingModel();
      trainingMod.id = response.data.idForma;
      trainingMod.presentation = response.data.presentation;
      trainingMod.public = response.data.public;
      trainingMod.goals = response.data.objectifs;
      trainingMod.competence = response.data.competence;
      trainingMod.thematique = response.data.thematique;
      trainingMod.cost = response.data.prix;
      trainingMod.duree = response.data.duree;
      trainingMod.methode = response.data.methode;
      trainingMod.evaluation = response.data.evaluation;
      trainingMod.quality = response.data.qualite;
      trainingMod.type = response.data.type;
      trainingMod.rating = response.data.rating;
      trainingMod.accessibility = response.data.accessibility;
      trainingMod.prixMax = response.data.priceMulti;
      trainingMod.groupes = response.data.groupes;
      trainingMod.groupesMax = response.data.groupesMax;
      trainingMod.qualification = response.data.qualification;
      trainingMod.cpf = response.data.cpf;
      trainingMod.prerequis = response.data.prerequis;
      trainingMod.ins_title = response.data.ins_title;
      trainingMod.ins_subtitle = response.data.ins_subtitle;
      trainingMod.ins_button = response.data.ins_button;
      trainingMod.ins_button_tel = response.data.ins_button_tel;
      let response2 = await TrainingService.fetchTrainingById(id);
      trainingMod.name = response2.data.training.name;
      if (response2.data.training.documents[0]) {
        trainingMod.document = response2.data.training.documents[0].file_url;
      }
      let sessions = []
      for (const session of response.data.sessions) {
        const sessionResponse = await TrainingService.fetchModifSessions(session);
        sessions.push(sessionResponse.data);
      }
      trainingMod.sessions = sessions
      trainingMod.modif = true
      trainingMod.idSecond = response.data.id;
      setTraining(trainingMod)
    } catch (error) {
      try {
        let response = await TrainingService.fetchTrainingById(id);
        let trainingMod = new TrainingModel();
        trainingMod.id = response.data.training.id;
        trainingMod.presentation = response.data.training.description;
        trainingMod.public = response.data.training.conditions.map(condition => condition.name).join('\n');
        trainingMod.goals = response.data.training.goals;
        trainingMod.competence = response.data.training.program[0].modules.map(module => module.description).join('\n');
        trainingMod.cost = response.data.training.training_price;
        trainingMod.duree = response.data.training.duration;
        trainingMod.name = response.data.training.name;
        trainingMod.type = response.data.training.training_cycle.id;
        trainingMod.accessibility = response.data.training.accessibility;
        trainingMod.prixMax = response.data.priceMulti;
        trainingMod.groupes = response.data.groupes;
        trainingMod.groupesMax = response.data.groupesMax;
        trainingMod.qualification = response.data.qualification;
        trainingMod.rating = response.data.training.statistic_success;
        trainingMod.prerequis = " ";
        trainingMod.modif = false
        if (response.data.training.documents[0]) {
          trainingMod.document = response.data.training.documents[0].file_url;
        }
        setTraining(trainingMod)
      } catch (error) {
        console.log("erreur" + error);
      }
    } finally {
      try {
        let response = await TrainingService.fetchTrainings();
        let incendieList = [];
        response.data.trainings.slice(0, 3).map(training => {
          incendieList.push(training);
        });
        setFormationsData(incendieList);
      } catch (error) {
        console.log("erreur" + error);
      } finally {
        setLoading(false); // Set loading to false after fetching data
      }
    }
  }
  return (GetFormaCompView(formationsData, training, loading, id))
}

export default GetFormaCompController;